import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as svgSources from './icons';

import './icon.styl'
class Loading extends Component {
    constructor(props) {
        super(props)
        let { type='bars' } = props
        this.state = {type};
    }

    render() {
        let {type} = this.state
        let component = svgSources[type] || '';
        return <div className="icon-loading" dangerouslySetInnerHTML={{__html: component}} />;
    }

}

Loading.propTypes = {
    type: PropTypes.string
}

export default Loading
